/**
 * @desc 暂存区日志分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stagingAreaMaster.logList.Params, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/logList`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
